import { render } from "./LicenseLockScreen.vue?vue&type=template&id=9527d82a&scoped=true"
import script from "./LicenseLockScreen.vue?vue&type=script&lang=js"
export * from "./LicenseLockScreen.vue?vue&type=script&lang=js"

import "./LicenseLockScreen.vue?vue&type=style&index=0&id=9527d82a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9527d82a"]])

export default __exports__